module.exports = __webpack_public_path__ + "img/rts_labeled.37c3f65a.jpg";